import styles from "./ExpiredRoomMessage.module.css";
import { Card, Typography } from "@mui/material";

const ExpiredRoomMessage = () => {
    return (
        <Card variant="elevation" className={styles.container} raised={true}>
            <Typography variant="paragraphMediumRegular" data-test-id="text_session_link_expired">
                This session link has expired.
            </Typography>
            <Typography variant="paragraphMediumRegular" data-test-id="text_contact_provider_details">
                Please contact your provider to make sure you have the correct meeting details.
            </Typography>
        </Card>
    );
};

export default ExpiredRoomMessage;
